import { useContext, useMemo } from "react";
import { MlGeoJsonLayer } from "@mapcomponents/react-maplibre";
import { MapPointContext } from "../context/MapPointContext";

export default function ActivePointLayer() {
  const mapPointContext = useContext(MapPointContext);

  const geojson = useMemo(() => {
    if (!mapPointContext.activePointFeature) {
      return undefined;
    }

    return {
      type: "FeatureCollection",
      features: [mapPointContext.activePointFeature],
    };
  }, [mapPointContext.activePointFeature]);

  const handleMarkerClick = (event) => {
    if (event?.originalEvent && !event.originalEvent.isTrusted) {
      return;
    }

    mapPointContext.clearActivePoint();
  };

  if (!geojson) {
    return <></>;
  }

  return (
   <>
   
   <MlGeoJsonLayer
     geojson={geojson}
     mapId="map_1"
     layerId="active-point-marker"
     type="circle"
     insertBeforeLayer="marker-result"
     onClick={handleMarkerClick}
     paint={{
       "circle-color": "#ff2010",  
       "circle-radius": 8,
       "circle-opacity": 0.95,
     }}
   />

   <MlGeoJsonLayer
     geojson={geojson}
     mapId="map_1"
     layerId="active-point-marker-2"
     type="circle"
     insertBeforeLayer="marker-result"
     onClick={handleMarkerClick}
     paint={{
       "circle-color": "#ff8c0000",
       "circle-radius": 10,
       "circle-stroke-color": "#ffffff",
       "circle-stroke-width": 4
     }}
   />
   </>
  );
}
